// @ts-nocheck
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import useZoneWidgets from "@store/Framework/Common/Hooks/useZoneWidgets";
import { useContext } from "react";

const useZoneIsActive = (contentId: string, zoneName: string) => {
    const shellContext = useContext(ShellContext);
    const zoneWidgets = useZoneWidgets(contentId, zoneName);

    return shellContext.isEditing || Boolean(zoneWidgets.length);
};

export default useZoneIsActive;
